__turbopack_context__.v({
  "SImgFromUrl": "XpEx0W_SImgFromUrl",
});
